import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PriceCurrencyPipe } from '@/common/pipes/price-currency.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';
import { AddSettlementBonusDialogComponent } from './add-settlement-bonus-dialog.component';
import { SalarySettlementBonusRowComponent } from './salary-settlement-bonus-row.component';

@Component({
	selector: 'app-salary-settlement-bonuses',
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatCardModule,
		MatDialogModule,
		MatExpansionModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		PriceCurrencyPipe,
		SalarySettlementBonusRowComponent,
	],
	templateUrl: './salary-settlement-bonuses.component.html',
	styleUrl: './salary-shared.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalarySettlementBonusesComponent {
	readonly state = inject(DriversSalaryV2StateService);
	private readonly dialog = inject(MatDialog);

	openAddDialog(): void {
		this.dialog
			.open(AddSettlementBonusDialogComponent, {
				width: '480px',
				data: { driverId: this.state.selectedDriverId(), month: this.state.selectedMonth() },
			})
			.afterClosed()
			.subscribe((created) => {
				if (created) {
					this.state.refreshSettlementBonuses();
				}
			});
	}
}
